// src/pages/LoginWrapper.jsx
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Login from './Login'

const LoginWrapper = () => {
    const { user } = useAuth()
    return user ? <Navigate to="/dashboard" replace /> : <Login />
}

export default LoginWrapper
